export default __webpack_public_path__ + "static/media/virus.e9956b56.png";